import shallow from 'zustand/shallow';
import { useCinemas } from '../state';

export const useCinema = () => {
  const selectedCinemas = useCinemas(s => s.selectedCinemas, shallow);

  return {
    selectedCinemas,
  };
};
